"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _playerActionTypes = _interopRequireDefault(require("../../player-action-types"));

class IndicatorCloak extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      hasIconAnimation: !!this.props.action
    });
    (0, _defineProperty2.default)(this, "onIndicatorAnimationEnd", () => {
      this.setState({
        hasIconAnimation: false
      });
      this.props.onShortcutChange(null);
    });
  }

  componentDidMount() {
    this.onIndicatorAnimationEnd();
    this.indicatorIconRef.addEventListener('webkitAnimationEnd', this.onIndicatorAnimationEnd); // webkit for Chrome, Safari and Opera

    this.indicatorIconRef.addEventListener('animationend', this.onIndicatorAnimationEnd);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.action !== nextProps.action) {
      this.setState({
        hasIconAnimation: !!nextProps.action
      });
    }
  }

  componentWillUnmount() {
    this.indicatorIconRef.removeEventListener('webkitAnimationEnd', this.onIndicatorAnimationEnd); // webkit for Chrome, Safari and Opera

    this.indicatorIconRef.removeEventListener('animationend', this.onIndicatorAnimationEnd);
  }

  renderProgressJumpNum() {
    const {
      action,
      skipSize
    } = this.props;

    if (action === _playerActionTypes.default.PROGRESS_BACK || action === _playerActionTypes.default.PROGRESS_FORWARD) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "indicator__jump-num"
      }, skipSize);
    }

    return null;
  }

  render() {
    const {
      action
    } = this.props;
    const {
      hasIconAnimation
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "indicator"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('indicator__icon', {
        'indicator--icon-animation': hasIconAnimation,
        'indicator--play': action === _playerActionTypes.default.PLAYING,
        'indicator--pause': action === _playerActionTypes.default.PAUSED,
        'indicator--mute': action === _playerActionTypes.default.MUTE,
        'indicator--volume-down': action === _playerActionTypes.default.VOLUME_DOWN,
        'indicator--volume-up': action === _playerActionTypes.default.VOLUME_UP,
        'indicator--progress-back': action === _playerActionTypes.default.PROGRESS_BACK,
        'indicator--progress-forward': action === _playerActionTypes.default.PROGRESS_FORWARD
      }),
      ref: c => {
        this.indicatorIconRef = c;
      }
    }, this.renderProgressJumpNum()));
  }

}

(0, _defineProperty2.default)(IndicatorCloak, "propTypes", {
  action: _propTypes.default.oneOf(Object.keys(_playerActionTypes.default)),
  onShortcutChange: _propTypes.default.func,
  skipSize: _propTypes.default.number
});
(0, _defineProperty2.default)(IndicatorCloak, "defaultProps", {
  action: null,
  onShortcutChange: () => {},
  skipSize: 5
});
var _default = IndicatorCloak;
exports.default = _default;